import { Controller } from '@hotwired/stimulus'

// Mounts the real widget renderer in the settings preview from the schema printed on the page:
// no fetch, no live booking link, so unsaved theme/label changes show for free.
export default class extends Controller {
  static targets = ['config', 'host']

  connect() {
    if (window.EightyEight) this.mount()
    else document.addEventListener('eightyeight:ready', () => this.mount(), { once: true })
  }

  mount() {
    if (!this.hasConfigTarget || !this.hasHostTarget) return

    const config = JSON.parse(this.configTarget.textContent)
    window.EightyEight.previewWidget(this.hostTarget, config)
  }

  replay() {
    if (window.EightyEight) window.EightyEight.remount(this.hostTarget)
  }
}
